import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerwarming = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M30.7 16H9.3A1.3 1.3 0 0 0 8 17.3v13.4A1.3 1.3 0 0 0 9.3 32h21.4a1.3 1.3 0 0 0 1.3-1.3V17.3a1.3 1.3 0 0 0-1.3-1.3"
    />
    <path
      fill="#B3E9B1"
      d="M29.25 19.25a1.25 1.25 0 1 0-2.5 0v9.5a1.25 1.25 0 1 0 2.5 0zM23.94 19.25a1.25 1.25 0 0 0-2.5 0v9.5a1.25 1.25 0 1 0 2.5 0zM18.62 19.25a1.25 1.25 0 1 0-2.5 0v9.5a1.25 1.25 0 0 0 2.5 0zM13.31 19.25a1.25 1.25 0 0 0-2.5 0v9.5a1.25 1.25 0 1 0 2.5 0z"
    />
    <path
      fill="#60D15D"
      d="M8 18v4a2 2 0 1 1 0-4"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M14.553 10.775c.105-.217.187-.389.187-.775h1c0 .609-.156.938-.29 1.216l-.003.009c-.105.217-.187.389-.187.775s.082.558.187.775l.004.009c.133.278.289.607.289 1.216s-.156.938-.29 1.216l-.003.009c-.105.217-.187.389-.187.775h-1c0-.609.156-.938.29-1.216l.003-.009c.105-.217.187-.389.187-.775s-.082-.558-.187-.775l-.004-.009A2.5 2.5 0 0 1 14.26 12c0-.609.156-.938.29-1.216zM20.447 9.898c-.185.388-.347.726-.347 1.442 0 .715.161 1.05.346 1.435l.005.01c.213.445.449.941.449 1.885s-.235 1.44-.45 1.885l-.004.01c-.185.384-.346.72-.346 1.435h-1c0-.94.236-1.434.45-1.878l.002-.006c.185-.385.348-.724.348-1.446s-.163-1.061-.348-1.446l-.003-.006c-.213-.444-.449-.939-.449-1.878s.236-1.436.449-1.882l.003-.006c.185-.388.348-.729.348-1.452h1c0 .943-.235 1.442-.449 1.89zM25.447 11.225c-.105.217-.187.389-.187.775s.082.558.187.775l.004.009c.133.278.289.607.289 1.216s-.156.938-.29 1.216l-.003.009c-.105.217-.187.389-.187.775h-1c0-.609.156-.938.29-1.216l.003-.009c.105-.217.187-.389.187-.775s-.082-.558-.187-.775l-.004-.009A2.5 2.5 0 0 1 24.26 12c0-.609.156-.938.29-1.216l.003-.009c.105-.217.187-.389.187-.775h1c0 .609-.156.938-.29 1.216z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerwarming);

export default ForwardRef;
